/* eslint-disable no-nested-ternary */
import React from "react";
import styled from "styled-components";
import { space, TypographyProps } from "styled-system";
import { GenericListProps as Props, SUBLIST_INDENTATION_INCREMENT_AMOUNT } from "../../types/GenericListType";
import { Box } from "../Box";
import { ListItem } from "../ListItem";
import { NestedList } from "../NestedList";
import { Title } from "../Title";

const UL = styled.ul`
  list-style: none;
  padding-inline-start: 0px;
  padding-left: 0px;
  margin: 0px;
`;

const Span = styled.span<any>`
  ${space}
  width: 100%;

  & > p:first-child {
    margin-top: 0px;
  }

  & > p:last-child {
    margin-bottom: 0px;
  }
`;

export const List: React.FC<Props & TypographyProps> = ({ icon, content, indentationLevel, title, color, ...props }) => {
  const definedIndentationLevel = indentationLevel || 0;
  return (
    <Box data-testid="ListComponent">
      {title && (
        <Title as="h4" mb="24px">
          {title}
        </Title>
      )}
      <Box
        bg={color}
        // Padding only applied to grey list, and only on the first set of list(s) - not nested lists.
        pt={color === "greyLight" && !indentationLevel ? 4 : 0}
        pb={color === "greyLight" && !indentationLevel ? 3 : 0}
        px={color === "greyLight" && !indentationLevel ? 4 : 0}
      >
        <UL>
          {content.map(contentItem => {
            return typeof contentItem === "string" ? (
              <ListItem
                key={contentItem.toString()}
                paddingLeft={definedIndentationLevel}
                icon={icon || "circle"}
                iconFontSize={icon === "circle" ? "10px" : 3}
                paddingBottom={3}
                {...props}
              >
                <Span ml={3} dangerouslySetInnerHTML={{ __html: contentItem }} />
              </ListItem>
            ) : (
              <NestedList
                key={contentItem.content.toString()}
                childListContentItem={contentItem}
                indentationLevel={definedIndentationLevel + SUBLIST_INDENTATION_INCREMENT_AMOUNT}
              />
            );
          })}
        </UL>
      </Box>
    </Box>
  );
};
